import React from "react";
import {
	cat12,
	total_orders,
	total_products,
	total_user,
} from "../../constants";
import "../../assets/css/seller-dashboard.css";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import Seller_sidebar from "./Seller-sidebar/Seller_sidebar";
import Seller_tabs_list from "./Seller-sidebar/Seller_tabs_list";
import Customer_profile from "./Seller-sidebar/Customer_profile";
import SellerHeader from "../../components/SellerHeader/SellerHeader";
import SellerFooter from "../../components/SellerFooter/SellerFooter";

const Seller_dashboard = () => {
	return (
		<>
			{/* Header starts here */}
			<SellerHeader />
			{/* Header ends here */}
			<section className="dashboard">
				<div className="container">
					<div className="row">
						<div className="col-lg-4">
							<Seller_sidebar />
							<Customer_profile />
						</div>
						<div className="col-lg-8">
							<Seller_tabs_list />
							<div className="row" style={{ marginTop: "30px" }}>
								{/* <!-- seller dashboard stats starts here --> */}
								<div className="col-lg-4">
									<div className="dashboard-stats-wrapper">
										<h6 className="item-label">Total Orders </h6>
										<div className="stats-and-number">
											<h2>950</h2>
											<img src={total_orders} alt="" />
										</div>
									</div>
								</div>
								<div className="col-lg-4">
									<div className="dashboard-stats-wrapper">
										<h6 className="item-label">Total Products</h6>
										<div className="stats-and-number">
											<h2>15</h2>
											<img src={total_products} alt="" />
										</div>
									</div>
								</div>
								<div className="col-lg-4">
									<div className="dashboard-stats-wrapper">
										<h6 className="item-label">Total Customer</h6>
										<div className="stats-and-number">
											<h2>45</h2>
											<img src={total_user} alt="" />
										</div>
									</div>
								</div>
								{/* <!-- seller dashboard stats ends here --> */}
							</div>
							<div className="row">
								<div className="col-lg-12">
									<div className="recent-orders-wrapper">
										<div className="content-wrapper">
											<h5>Recent Orders</h5>
										</div>
										<div className="table-responsive">
											<table className="table">
												<thead>
													<tr>
														<th scope="col">Order ID</th>
														<th scope="col">Billing Name</th>
														<th scope="col">Amount</th>
														<th scope="col">Items</th>
														<th scope="col">Shipment Status</th>
														<th scope="col">Action</th>
													</tr>
												</thead>
												<tbody>
													<tr>
														<th className="num" scope="row">
															#12345
														</th>
														<td className="name">Koizuma Massage</td>
														<td className="price">$550</td>
														<td className="item">2</td>
														<td className="shipment">Unshipped</td>
														<td className="details">
															<a href="/seller-order-details">View Details</a>
														</td>
													</tr>
													<tr>
														<th className="num" scope="row">
															#12345
														</th>
														<td className="name">Koizuma Massage</td>
														<td className="price">$550</td>
														<td className="item">2</td>
														<td className="shipment">Unshipped</td>
														<td className="details">
															<a href="#">View Details</a>
														</td>
													</tr>
													<tr>
														<th className="num" scope="row">
															#12345
														</th>
														<td className="name">Koizuma Massage</td>
														<td className="price">$550</td>
														<td className="item">2</td>
														<td className="shipment">Unshipped</td>
														<td className="details">
															<a href="#">View Details</a>
														</td>
													</tr>
													<tr>
														<th className="num" scope="row">
															#12345
														</th>
														<td className="name">Koizuma Massage</td>
														<td className="price">$550</td>
														<td className="item">2</td>
														<td className="shipment">Unshipped</td>
														<td className="details">
															<a href="#">View Details</a>
														</td>
													</tr>
													<tr>
														<th className="num" scope="row">
															#12345
														</th>
														<td className="name">Koizuma Massage</td>
														<td className="price">$550</td>
														<td className="item">2</td>
														<td className="shipment">Unshipped</td>
														<td className="details">
															<a href="#">View Details</a>
														</td>
													</tr>
													<tr>
														<th className="num" scope="row">
															#12345
														</th>
														<td className="name">Koizuma Massage</td>
														<td className="price">$550</td>
														<td className="item">2</td>
														<td className="shipment">Unshipped</td>
														<td className="details">
															<a href="#">View Details</a>
														</td>
													</tr>
												</tbody>
											</table>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			{/* Footer starts here */}
			<SellerFooter />
			{/* Footer ends here */}
		</>
	);
};

export default Seller_dashboard;
